import React from 'react';
import { Hero } from '../components/Hero';
import { MarqueeBand } from '../components/MarqueeBand';
import { FeaturedProperties } from '../components/FeaturedProperties';
import { Mission } from '../components/Mission';
import { WhyChoose } from '../components/WhyChoose';
import { Stats } from '../components/Stats';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { Partners } from '../components/Partners';
import { BookInspection } from '../components/BookInspection';
export function Home() {
  return <>
      <Hero data-id="element-1133" />
      <MarqueeBand data-id="element-1134" />
      <FeaturedProperties data-id="element-1135" />
      <Mission data-id="element-1136" />
      <WhyChoose data-id="element-1137" />
      <Stats data-id="element-1138" />
      <Process data-id="element-1139" />
      <Testimonials data-id="element-1140" />
      <Partners data-id="element-1141" />
      <BookInspection data-id="element-1142" />
    </>;
}